'use strict';

var illustration = {};

exports.__exports = illustration;
//# sourceMappingURL=illustration.cjs.map
